import { getUserAgent } from '../common';

const AVIF_IMAGE =
  'AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';

//Fn will check for AVIF compatibility on client and set attributes on window object.
export const checkAvifCompatible = (isAvifCompatible = false): void => {
  if (isAvifCompatible || window.isAvifCompatible) {
    window.isAvifCompatible = isAvifCompatible || window.isAvifCompatible;
    return;
  }
  const avifImage = new Image();
  avifImage.onload = () => {
    // change "AVIF_COMPATIBLE" flag
    window.isAvifCompatible = avifImage.width > 0 && avifImage.height > 0;
  };
  avifImage.onerror = () => {
    if (getUserAgent().includes('Safari')) {
      window.isAvifCompatible = false;
    }
  };
  avifImage.src = `data:image/avif;base64,${AVIF_IMAGE}`;
};
